import React from "react";
import useSlider from "@hooks/useSlider";
import Image from "next/image";

interface AiChatbotSectionsPropsArray {
    title: string;
    img: string;
    desc?: string;
    features?: string[];
}

interface AiChatbotSectionsProps {
    titleText?: string;
    desc?: string;
    AiChatbotSectionsPropsData: AiChatbotSectionsPropsArray[];
}

const AiChatbotSectionMobile: React.FC<AiChatbotSectionsProps> = (props) => {
    const { titleText, desc, AiChatbotSectionsPropsData = [] } = props;
    const { loaded, refCallback, currentSlide, slider } = useSlider();
    return (
        <div className="px-4 lg:hidden pt-10">
            {titleText && (
                <h2 className="md:text-6xl text-6xl font-semibold md:pb-10 max-w-7xl mx-auto px-5 font-degular">
                    <span className="text-black">{titleText}</span>&nbsp;
                    <br />
                    <span className="text-blue-500 font-degular">{desc}</span>
                </h2>
            )}

            <section className="section-testimonial bg-lightBlue rounded-2xl mx-auto mt-10">
                <div ref={refCallback} className="keen-slider" style={{ height: "90%" }}>
                    {AiChatbotSectionsPropsData.map((data, index) => (
                        <div className="keen-slider__slide slider-card relative" key={index}>
                            <div className="flex flex-col h-full p-5">
                                <div className="p-2">
                                    <h3 className="font-semibold text-4.5xl font-degular">{data.title}</h3>
                                </div>
                                {data.desc && (
                                    <div className="">
                                        <p className="text-center text-base text-gray-500">{data.desc}</p>
                                    </div>
                                )}
                                {data?.features && (
                                    <ul className="list-none mt-4" style={{ marginLeft: "0px !important" }}>
                                        {data.features?.map((feature, idx) => (
                                            <div key={idx} className="flex items-center gap-1">
                                                <div className="flex-shrink-0">
                                                    <Image
                                                        src={"https://assets.gallabox.com/gb-home/ai-chatbot/lightblue-circle-tick.svg"}
                                                        width={24}
                                                        height={24}
                                                        alt="tick-circle"
                                                    />
                                                </div>
                                                <li className="list-none text-md font-inter  text-base">{feature}</li>
                                            </div>
                                        ))}
                                    </ul>
                                )}
                                <div className="mt-10">
                                    <Image width={273} height={322} src={data.img} className="w-full" alt={`${data.title} image`} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {loaded && slider.current && (
                    <div className="carousal-dots pb-8">
                        {[...Array(slider.current.track.details.slides.length).keys()].map((idx) => (
                            <button
                                key={idx}
                                onClick={() => {
                                    slider.current?.moveToIdx(idx);
                                }}
                                className={"carousal-dot" + (currentSlide === idx ? " active" : "")}
                            ></button>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default AiChatbotSectionMobile;
